// Shared loader so google_map.svelte and place_search.svelte (which are typically used
// together on the same page) only ever inject the Maps JS API script tag once.
let loaderPromise = null

export const loadGoogleMaps = (apiKey) => {
  if (!apiKey) return Promise.reject(new Error('missing_api_key'))
  if (window.google?.maps) return Promise.resolve(window.google.maps)
  if (loaderPromise) return loaderPromise

  loaderPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}&libraries=places`
    script.async = true
    script.onload = () => resolve(window.google.maps)
    script.onerror = () => reject(new Error('failed_to_load_google_maps'))
    document.head.appendChild(script)
  })

  return loaderPromise
}
